import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TenantProfileService } from '../../core/services/tenant-profile.service';

@Component({
	selector: 'app-footer',
	imports: [RouterLink, FaIconComponent],
	templateUrl: './footer.html',
})
export class Footer {
	// Identitas dinamis (fallback environment.brand di service).
	readonly brand = inject(TenantProfileService).brand();
	readonly year = new Date().getFullYear();

	// Kolom "Informasi" — tautan informasi & bantuan.
	readonly nav = [
		{ label: 'Blog', path: '/blog' },
		{ label: 'Lacak Booking', path: '/lacak' },
		{ label: 'Hubungi Kami', path: '/hubungi-kami' },
		{ label: 'Syarat & Ketentuan', path: '/syarat-ketentuan' },
		{ label: 'Kebijakan Privasi', path: '/kebijakan-privasi' },
	];

	// Kolom "Layanan" — jenis paket (filter ?packageType pada halaman /paket).
	readonly layanan = [
		{ label: 'Paket Umrah', packageType: 'umrah' },
		{ label: 'Paket Haji', packageType: 'hajj' },
		{ label: 'Paket Trip Halal', packageType: 'halal_trip' },
	];
}
